var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIterate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 51.1999H8.73C7.0573 51.1972 5.45386 50.5316 4.27108 49.3488C3.0883 48.166 2.42264 46.5626 2.42 44.8899L0 14.9899C0 14.2314 0.301321 13.5039 0.837675 12.9676C1.37403 12.4312 2.10148 12.1299 2.86 12.1299H34.86C35.6194 12.1299 36.3479 12.4309 36.8859 12.9669C37.4238 13.503 37.7274 14.2304 37.73 14.9899L35.3 44.8899C35.3 46.5617 34.6366 48.1651 33.4554 49.3482C32.2742 50.5313 30.6718 51.1972 29 51.1999Z",
    fill: "#3098F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6701 19.5802C38.7301 19.5802 46.0001 18.6502 46.0001 28.2302C45.998 29.5503 45.7312 30.8566 45.2153 32.0718C44.6994 33.2869 43.945 34.3862 42.9968 35.3046C42.0485 36.223 40.9257 36.9419 39.6947 37.4186C38.4637 37.8954 37.1496 38.1204 35.8301 38.0802",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.29 23.33C37.49 23.33 41.75 22.79 41.75 28.4C41.7479 29.1762 41.5894 29.9441 41.2841 30.6577C40.9788 31.3714 40.5328 32.0162 39.9729 32.5538C39.4129 33.0914 38.7504 33.5106 38.0249 33.7866C37.2993 34.0625 36.5257 34.1895 35.75 34.16",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1498 1.08011C13.9298 1.07011 12.3798 3.46011 14.0898 4.58011C14.9398 5.11011 16.4298 5.36011 16.3398 6.91011C16.1498 10.4201 13.3398 8.06011 14.4098 11.3001",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2597 2.47998C22.983 2.56815 22.742 2.74324 22.5727 2.97924C22.4034 3.21523 22.3146 3.49956 22.3197 3.78998C22.3197 5.09998 23.9697 5.38998 24.0097 6.85998C24.0797 9.54998 21.7297 8.17998 22.3197 11.25",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87012 28.2501C10.6001 26.6701 12.6901 21.1701 19.5001 21.3701C23.0901 21.4801 25.9201 22.8801 26.9701 26.4201",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16016 25.1499C9.35813 26.3118 9.63884 27.458 10.0002 28.5799C11.1788 27.8297 12.4281 27.1967 13.7302 26.6899",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4801 32.5801C26.7501 34.1601 24.6501 39.6601 17.8401 39.4601C14.2601 39.3601 11.4301 37.9501 10.3701 34.4601",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1796 35.7003C27.9932 34.5364 27.7258 33.387 27.3796 32.2603C26.1968 33.0094 24.9443 33.6423 23.6396 34.1503",
    stroke: "#092C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 50.62,
    fill: "white",
    transform: "translate(0 0.580078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIterate);
export default __webpack_public_path__ + "static/media/icon-iterate.f3c7c97870efdb7a3e33bf96e5e87741.svg";
export { ForwardRef as ReactComponent };